// Local wall-clock helpers for a tell's "when". The server stores whenLocal (what the gardener
// saw) and whenOffsetMinutes; the app never converts through UTC for display.

const pad = (n: number) => String(n).padStart(2, '0');

/** "YYYY-MM-DDTHH:MM" for now, in the device's local time (what <input type=datetime-local> wants). */
export function nowLocal(date = new Date()): string {
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
}

/** Minutes east of UTC right now (New Zealand daylight time = 780). */
export const offsetMinutes = (date = new Date()): number => -date.getTimezoneOffset();

/** "YYYY-MM-DD" for today, local. */
export const todayLocal = (date = new Date()): string => nowLocal(date).slice(0, 10);

/** "2:10 pm" from a whenLocal. */
export function formatTime(whenLocal: string): string {
    const h = Number(whenLocal.slice(11, 13));
    const m = whenLocal.slice(14, 16);
    const suffix = h >= 12 ? 'pm' : 'am';
    const hour = h % 12 === 0 ? 12 : h % 12;
    return `${hour}:${m} ${suffix}`;
}

const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
const DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

const parseLocalDate = (ymd: string): Date => new Date(Number(ymd.slice(0, 4)), Number(ymd.slice(5, 7)) - 1, Number(ymd.slice(8, 10)));

/** "Fri 17 Oct 2026" from a whenLocal or date. */
export function formatDateShort(whenLocal: string): string {
    const d = parseLocalDate(whenLocal.slice(0, 10));
    return `${DAYS[d.getDay()].slice(0, 3)} ${d.getDate()} ${MONTHS[d.getMonth()].slice(0, 3)} ${d.getFullYear()}`;
}

/** "17 Oct" from a whenLocal or date. */
export function formatDayMonth(whenLocal: string): string {
    const d = parseLocalDate(whenLocal.slice(0, 10));
    return `${d.getDate()} ${MONTHS[d.getMonth()].slice(0, 3)}`;
}

/**
 * A day-group header: "Today", "Yesterday", a weekday within the last week, then
 * "Friday 10 October", and the year once it differs.
 */
export function dayLabel(ymd: string, today: string): string {
    if (ymd === today) return 'Today';
    const d = parseLocalDate(ymd);
    const t = parseLocalDate(today);
    const diffDays = Math.round((t.getTime() - d.getTime()) / 86_400_000);
    if (diffDays === 1) return 'Yesterday';
    if (diffDays > 1 && diffDays < 7) return DAYS[d.getDay()];
    const base = `${DAYS[d.getDay()]} ${d.getDate()} ${MONTHS[d.getMonth()]}`;
    return d.getFullYear() === t.getFullYear() ? base : `${d.getDate()} ${MONTHS[d.getMonth()]} ${d.getFullYear()}`;
}
